<template>
  <div class="loginCon dialog-con">
    <div class="dialog-con-bg"></div>
    <div class="dialog-warp loginWrap" v-if="activeIndex == 1">
        <div class="login-logo">
            <img src="@/assets/login/login_bg.png">
        </div>
        <div class="login-accout">
            <div class="welcome">Hi! Welcome to Black Gemstone</div>
            <div class="l-item-con f16 email flexible aItem-center" @click="activeIndex = 2">
                <img src="../../assets/login/ic_email.png"/>
                <span>Sign In With Email</span>
            </div>
            <div class="l-item-con f16 facebook f-csp flexible aItem-center" @click="onFBLogin()">
                <img src="../../assets/login/ic_facebook.png"/>
                <span class="font-MT">{{$lang('login.fblogin')}}</span>
                <i class="el-icon-loading" v-if="fbLoading"></i>
            </div>
            <g-signin-button
                :params="googleSignInParams"
                @success="onSignInSuccess"
                @error="onSignInError">
                <div class="l-item-con f16 iphone f-csp flexible aItem-center">
                    <img src="../../assets/login/ic_iphone.png"/>
                    <span class="font-MT">{{$lang('login.googlelogin')}}</span>
                    <i class="el-icon-loading" v-if="googleLoading"></i>
                </div>
            </g-signin-button>
        </div>
    </div>
    <email-login v-if="activeIndex == 2" @email-login="emailLogin" @update-index="updateIndex"></email-login>
    <email-register v-if="activeIndex == 3" @update-index="updateIndex"></email-register>
    <div class="dialog-close" @click="closelogin()">
      <img src="../../assets/login/ic_close.png"/>
    </div>
  </div>
</template>

<script>
import VFacebookLogin from 'vue-facebook-login-component';
import EmailRegister from './components/emailRegister.vue';
import EmailLogin from './components/emailLogin.vue';
export default {
  components: {VFacebookLogin, EmailRegister, EmailLogin},
  data() {
    return {
        /*facebook*/
        fbSignInParams: {
            scope: 'email,user_likes',
            return_scopes: true
        },
        fbLoading: false,
        /*google*/
        googleSignInParams:{
            // client_id: '1091104845468-dkcluvl364g1aak2c046th3mol5k9d4j.apps.googleusercontent.com'
            client_id: '275356979130-0oupu9o675uh92jcl2tief8iv4r7qq6v.apps.googleusercontent.com',
            plugin_name: 'Meetnovel',
            cookiepolicy: 'single_host_origin',
        },
        googleLoading: false,
        loginType: null,
        googleToken: '',
        fbParams: {},
        envType: '',
        emailForm: {
            account: '',
            password: ''
        },
        activeIndex: 1,
    };
  },
    created() {
      this.loadFBSDK()
        this.envType = process.env.VUE_APP_CURRENTMODE
    },
    methods: {
        updateIndex(index) {
            this.activeIndex = index;
        },
        loadFBSDK() {
            const params = `#version=v3.3&appId=759227502195302&status=true&cookie=true&xfbml=true&autoLogAppEvents=true`;
            (function(d, s, id) { // Load the SDK asynchronously
                var js; var fjs = d.getElementsByTagName(s)[0]
                if (d.getElementById(id)) return
                js = d.createElement(s); js.id = id
                js.src = 'https://connect.facebook.net/zh_TW/sdk.js' + params
                fjs.parentNode.insertBefore(js, fjs)
            }(document, 'script', 'facebook-jssdk'))
        },
        onFBLogin() {
            const _this = this
            // 检测FB登录状态
            _this.fbLoading = true
            FB.getLoginStatus(function(response) { // Called after the JS SDK has been initialized.
                console.log(response)
                if (response.status === 'connected') { // 已登录
                    _this.loginType = 7
                    _this.fbParams.thirdToken = response.authResponse.accessToken
                    _this.fbParams.thirdType = 7
                    _this.fbParams.thirdUserId = response.authResponse.userID
                    _this.loginFun()
                } else { // 未登录进行登录
                    FB.login(function(res) {
                        console.log(res)
                        if (res.status === 'connected') {
                            _this.loginType = 7
                            _this.fbParams.thirdToken = res.authResponse.accessToken
                            _this.fbParams.thirdType = 7
                            _this.fbParams.thirdUserId = res.authResponse.userID
                            _this.loginFun()
                        } else {
                            _this.fbLoading = false
                        }
                    })
                }
            })
        },
        // 登录框关闭
        closelogin () {
          this.$emit('changeLogin', false)
        },
        // google登录
        onSignInSuccess (googleUser) {
            this.googleToken = googleUser.xc.id_token
            this.loginType = 8
            this.googleLoading = true
            this.loginFun()
        },
        onSignInError (error) {
            console.log(error)
            this.$faild('custom', error.error)
            this.googleLoading = false
        },
        emailLogin(params) {
            this.emailForm.account = params.account;
            this.emailForm.password = params.password;
            this.loginFun();
        },
        // 登录回调
        loginFun () {
            let data = {}
            if (this.loginType == 7) {
                data = {
                    facebookToken: this.fbParams.thirdToken,
                    thirdType: 7,
                    thirdUserId: this.fbParams.thirdUserId,
                    thirdUserName: '',
                    confirm: '',
                    fbUserName: '',
                    headUrl: '',
                }
            } else if (this.loginType == 8) {
                data = {
                    token: this.googleToken
                }
            } else {
                data = {
                    // account: 'zhangxiaoyan@heiyan.com',
                    account: this.emailForm.account,
                    password: this.emailForm.password
                }
            }
            this.$store.dispatch('Login', {loginInfo: data, type: this.loginType}).then((res) => {
                if (res.success) {
                    if (res.success) {
                        this.$emit('createFun')
                        this.fbLoading = false
                        this.googleLoading = false
                        this.closelogin()
                    }
                }
            })
        },
    },
    mounted() {}
};
</script>
<style lang="scss" scoped>
    /deep/.el-input{
        font-size: 16px !important;
    }
    .loginWrap{
        width: 420px;
        padding: 20px 0 32px;
        background: #fff;
        border-radius: 34px;
        .login-logo{
            position: absolute;
            left: 50%;
            top: -50px;
            transform: translateX(-50%);
            >img{
                width: 246px;
                height: 150px;
            }
        }
        .login-accout{
            width: 333px;
            margin: auto;
            margin-top: 100px;
            .welcome{
                font-family: 'PingFangSC';
                text-align: center;
                font-size: 18px;
                color: #666;
                margin-bottom: 30px;
            }
            .l-item-con{
                width: 333px;
                height: 46px;
                border-radius: 49px;
                margin-top: 16px;
                font-weight: 500;
                span{
                    margin-left: 33px;
                }
                img{
                    margin-left: 20px;
                }
                i{
                    right: 20px;
                }
            }
            .email{
                background: #ECF8E9;
                color: #498F34;
                img{
                    height:15px;
                    width: 19px;
                }
            }
            .facebook{
                background: #F20C97;
                color: #fff;
                img{
                    height: 20px;
                    width: 20px;
                }
            }
            .iphone{
                background: #1D1E1F;
                color: #fff;
                img{
                    height:20px;
                    width: 20px;
                }
            }
        }
    }
</style>